import React from 'react';

const DoorsIcon = () => (
  <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
    <rect x="4" y="2" width="16" height="20" rx="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path strokeLinecap="round" d="M4 9h16"/>
    <circle cx="16.5" cy="14" r="1.2" fill="currentColor" stroke="none"/>
  </svg>
);

const SeatsIcon = () => (
  <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path strokeLinecap="round" strokeLinejoin="round" d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
  </svg>
);

const GearShiftIcon = () => (
  <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
    <circle cx="12" cy="5" r="2.5"/>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5V13"/>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 13h8"/>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 13v3a1 1 0 01-1 1H6a1 1 0 01-1-1v-3"/>
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 13v3a1 1 0 001 1h1a1 1 0 001-1v-3"/>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 13v5"/>
    <circle cx="12" cy="19" r="1.5" fill="currentColor" stroke="none"/>
  </svg>
);

const FuelIcon = () => (
  <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 22V6a2 2 0 012-2h8a2 2 0 012 2v16"/>
    <path strokeLinecap="round" d="M3 11h12"/>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 6l4 2v5.5a1.5 1.5 0 01-3 0V11"/>
  </svg>
);

export default function CarCard({ car, onBook }) {
  const trans = car.transmission === 'Automatic' ? 'Auto' : car.transmission === 'Manual' ? 'Manual' : car.transmission || '—';

  return (
    <div className="car-card">
      <div className="car-card-img-wrap">
        {car.image
          ? <img className="car-card-img" src={car.image} alt={car.name} />
          : <div className="car-card-img" style={{ display:'flex', alignItems:'center', justifyContent:'center', background:'#F3F4F6' }}>
              <svg width="80" height="50" fill="none" viewBox="0 0 120 65" stroke="#CCC" strokeWidth="2.5">
                <rect x="5" y="20" width="110" height="35" rx="6"/>
                <circle cx="28" cy="58" r="7"/>
                <circle cx="92" cy="58" r="7"/>
                <path d="M5 35h110M28 20l8-15h48l8 15"/>
              </svg>
            </div>
        }
        <div className="car-card-badge">
          {car.available
            ? <span className="badge badge-green">Available</span>
            : <span className="badge badge-gray">Unavailable</span>}
        </div>
        {!car.available && <div className="car-card-unavailable">Currently Rented</div>}
      </div>

      <div className="car-card-body">
        <div className="car-card-top">
          <div>
            <div className="car-card-name">{car.name}</div>
            <div className="car-card-category">{car.category}</div>
          </div>
          <div>
            <div className="car-card-price">€{car.price}</div>
            <div className="car-card-price-label">per day</div>
          </div>
        </div>

        <div className="car-card-specs">
          {car.doors && (
            <div className="spec-item">
              <div className="spec-icon"><DoorsIcon /></div>
              <div className="spec-val">{car.doors}</div>
              <div className="spec-lbl">Doors</div>
            </div>
          )}
          <div className="spec-item">
            <div className="spec-icon"><SeatsIcon /></div>
            <div className="spec-val">{car.seats}</div>
            <div className="spec-lbl">Seats</div>
          </div>
          <div className="spec-item">
            <div className="spec-icon"><GearShiftIcon /></div>
            <div className="spec-val">{trans}</div>
            <div className="spec-lbl">Trans</div>
          </div>
          <div className="spec-item">
            <div className="spec-icon"><FuelIcon /></div>
            <div className="spec-val">{car.fuel}</div>
            <div className="spec-lbl">Fuel</div>
          </div>
        </div>
      </div>

      <div className="car-card-action">
        <button
          className="btn-primary"
          disabled={!car.available}
          style={!car.available ? { opacity:0.4, cursor:'not-allowed' } : {}}
          onClick={() => car.available && onBook(car)}
        >
          {car.available ? 'Book Now' : 'Unavailable'}
        </button>
      </div>
    </div>
  );
}